import { useFlags } from 'lib/featureFlags/hooks/useFlags';
import Head from 'next/head';
import { useTranslation } from 'react-i18next';

import { DashboardLayout } from './DashboardLayout';
import { DashboardLegacy } from './legacy/DashboardLegacy';
import { DashboardWrapper } from './LookerDashboardSideBar.styles';

export function Dashboard({ currentSectionIndex }: { currentSectionIndex: string }) {
  const { t } = useTranslation('Dashboard');
  const { showDashboardSections } = useFlags();

  return (
    <DashboardWrapper $height={'100%'}>
      <Head>
        <title>{t('title')} | Coachhub Company Dashboard</title>
      </Head>
      {showDashboardSections ? (
        <DashboardLayout currentSectionIndex={currentSectionIndex} />
      ) : (
        <DashboardLegacy />
      )}
    </DashboardWrapper>
  );
}
